import { template as template_880fe855934d45fcafb07db58677a0df } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import { Model } from '../../routes/render/html';
export default RouteTemplate(template_880fe855934d45fcafb07db58677a0df(`
  <@model.Component @format={{@model.format}} />
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
